<template>
  <v-form ref="form" v-model="valid" lazy-validation class="form_class">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          class="mx-0 font-weight-light"
          color="primary"
          @click.native="selectFile"
          :disabled="!utility_company || disabled || uploading"
        >
          <v-progress-circular
            v-if="uploading"
            indeterminate
            size="16"
            class="mr-2"
          ></v-progress-circular>
          <v-icon v-else left aria-hidden="true">add_a_photo</v-icon>
          {{
            fileName ? fileName.substring(0, 30) : "ADICIONAR CONTA DE ENERGIA"
          }}
        </v-btn>
      </template>
      <span>{{
        fileName && fileName.length > 30
          ? fileName
          : "Apenas PDFs da 2º via de conta original emitidos pela concessionária são permitidos."
      }}</span>
    </v-tooltip>
    <input
      id="files"
      type="file"
      capture="camera"
      name="file"
      ref="uploadInput"
      accept="application/pdf"
      :multiple="true"
      @change="detectFiles($event)"
    />
    <v-snackbar
      :color="snack.color"
      :bottom="snack.bottom"
      :top="snack.top"
      :left="snack.left"
      :right="snack.right"
      v-model="snack.snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snack.snackMessage }}</div>
      <v-icon size="16" @click="snack.snackbar = false">
        mdi-close-circle
      </v-icon>
    </v-snackbar>
  </v-form>
</template>
<script>
import { uploadEnergyBillData } from "../../services/sales";
import { uploadInvoice } from "../../services/uploadInvoice";
import { mapMutations, mapGetters, mapState } from "vuex";
import { eventBus } from "../../main";
import statesfile from "@/model/state";
export default {
  props: {
    utility_company: {
      type: String,
      default: "",
    },
    cpf: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    user_id: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      loading: true,
      valid: false,
      fileName: "",
      uploadTask: "",
      uploading: false,
      dialog: false,
      alert: true,
      snack: {
        color: null,
        top: true,
        bottom: false,
        left: false,
        right: false,
        snackMessage: "",
        snackbar: false,
      },
      states: statesfile.estados,
    };
  },
  created() {
    eventBus.$on("consumerunit", (consumerunit) => {
      if (consumerunit.type === "new") {
        // console.log('consumerunit: ', consumerunit.data)
        this.uploading = false;
      }
    });
  },
  computed: {
    ...mapState("sales", ["subclasses"]),
    ...mapGetters(["loggedUser"]),
  },
  methods: {
    ...mapMutations("sales", ["setConsumerUnitUploaded"]),
    selectFile() {
      this.$refs.uploadInput.click();
    },
    async detectFiles(e) {
      const fileList = e.target.files || e.dataTransfer.files;
      for (const file of fileList) {
        this.uploading = true;
        var formData = new FormData();
        formData.append("invoice", file);
        formData.append("utility_company", this.utility_company);
        this.uploadInv(formData)
          .then(async (res) => {
            this.fileName = file.name;
            let tarifa_energia = 0;

            let _history = [
              { mes_ano: "mês 1", consumo: 0, dias: 30 },
              { mes_ano: "mês 2", consumo: 0, dias: 30 },
              { mes_ano: "mês 3", consumo: 0, dias: 30 },
            ];
            if (res.data.historico) {
              _history = res.data.historico.map((h) => {
                return {
                  mes_ano: h.competencia,
                  consumo: h.consumo,
                  dias: h.dias,
                };
              });
            }

            if (
              this.utility_company === "cemig" &&
              res.data?.valores_faturados
            ) {
              const energia_eletrica = res.data.valores_faturados.find((t) =>
                t.descricao.includes("Energia Elétrica"),
              );
              tarifa_energia = energia_eletrica.tarifa_preco;
            } else if (
              this.utility_company === "neoenergia-pe" ||
              this.utility_company === "neoenergia-ba" ||
              this.utility_company === "cpfl-piratininga"
            ) {
              const tusdRgx = /Consumo(\s*([A-Za-z]*\s*)*)(\[KWh\])*-TUSD/;
              const teRgx = /Consumo\s*-\s*TE/;
              const consumo_tusd = res.data.valores_faturados.find((t) =>
                tusdRgx.test(t.descricao),
              );
              const consumo_te = res.data.valores_faturados.find((t) =>
                teRgx.test(t.descricao),
              );
              tarifa_energia =
                consumo_tusd.tarifa_preco + consumo_te.tarifa_preco;
            }

            let street = res.data.endereco?.rua;
            let number = "";
            let complement = "";

            if (["cemig", "neoenergia-pe"].includes(this.utility_company)) {
              street = res.data.endereco?.rua?.match(/^([A-Z]+\s)+[A-Z]+/)[0];
              number = res.data.endereco?.rua?.match(/\d+/)[0];
              complement = res.data.endereco?.rua?.match(/\d+(.+)/)[1]?.trim();
            }

            if (street?.startsWith("ENDEREÇO: ")) {
              street = street?.slice("ENDEREÇO: ".length);
            }

            const uc = {
              status: "awaiting_contract_generation",
              installation_number: res.data.numero_instalacao,
              customer_number: res.data.numero_cliente,
              utility_company: this.utility_company,
              fare_amount: tarifa_energia,
              rate_class: this.mapClasse(res.data.classe),
              sub_class: this.mapSubClasse(res.data.subclasse),
              history: _history,
              name: res.data.nome,
              person_type: this.getPersonType(res.data),
              cpf: this?.cpf,
              average: 0,
              percentage: 0,
              percentage_discount: 10,
              creditos: 0,
              mensalidade: 0,
              economia_mensal: 0,
              economia_anual: 0,
              economia_contrato: 0,
              address: {
                address: street,
                address_number: number,
                address_complement: complement,
                district: res.data.endereco.bairro,
                postal_code: res.data.endereco.cep,
                state: this.states?.find(
                  (item) => item.initials === res.data.endereco.estado,
                ),
                city: res.data.endereco.cidade,
                country: {
                  name: "Brasil",
                  initials: "BR",
                },
              },
              user: {
                name: res.data.nome,
                cpf: this?.cpf,
              },
            };

            if (res.data.cpf || res.data.cnpj) {
              uc.cpf = res.data?.cpf || res.data?.cnpj;
              uc.person_type = uc.cpf.length > 11 ? "pj" : "pf";
            }

            await uploadEnergyBillData({
              id: this.user_id,
              data: [file],
              agent_email: this.loggedUser?.email,
            });
            this.setConsumerUnitUploaded(uc);
            eventBus.$emit("consumerunit", { type: "new", data: uc });
            this.uploading = false;
          })
          .catch((error) => {
            console.error(error);
            this.show_snack(
              "Apenas PDFs da 2º via de conta original emitidos pela concessionária são permitidos",
              "error",
              "top",
            );
            this.$refs.uploadInput.value = null;
            this.uploading = false;
          });
      }
    },
    async uploadInv(formData) {
      return await uploadInvoice(formData);
    },
    show_snack(message, color, ...args) {
      this.snack.top = true;
      this.snack.bottom = false;
      this.snack.left = false;
      this.snack.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.snack.color = color;
      this.snack.snackMessage = message;
      this.snack.snackbar = true;
    },
    competenceToMonth(value) {
      if (!value) return;
      const split = value.split("-");
      const year = split[0].slice(2);
      const month = split[1];
      switch (month) {
        case "01":
          return `JAN/${year}`;
        case "02":
          return `FEV/${year}`;
        case "03":
          return `MAR/${year}`;
        case "04":
          return `ABR/${year}`;
        case "05":
          return `MAI/${year}`;
        case "06":
          return `JUN/${year}`;
        case "07":
          return `JUL/${year}`;
        case "08":
          return `AGO/${year}`;
        case "09":
          return `SET/${year}`;
        case "10":
          return `OUT/${year}`;
        case "11":
          return `NOV/${year}`;
        case "12":
          return `DEZ/${year}`;
        default:
          return;
      }
    },

    mapClasse(value) {
      const _value = value.toLowerCase();
      if (_value.includes("monofásico")) return "Monofásico";
      if (_value.includes("bifásico")) return "Bifásico";
      if (_value.includes("trifásico")) return "Trifásico";
      return value;
    },

    mapSubClasse(value) {
      const _value = value.toLowerCase();
      const subclass = this.subclasses?.find((item) => (item.subclass = value));
      if (subclass) return subclass;
      if (_value.includes("comercial")) return "Comercial";
      if (_value.includes("residencial")) return "Residencial";
      return value;
    },

    getPersonType(data) {
      if (data.cpf || data.cpf_anon) {
        return "pf";
      }
      if (data.cnpj || data.cnpj_anon) {
        return "pj";
      }
      return null;
    },
  },
};
</script>
<style scoped>
.progress-bar {
  margin: 10px 0;
}
input[type="file"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}
</style>
